function initializeAutocomplete() {
  const addressElements = document.querySelectorAll('.autocomplete-address');
  const zipCodeElements = document.querySelectorAll('.autocomplete-zip-code');

  Array.from(addressElements).forEach((element) => {
    const inputId = element.dataset['inputId'];
    const autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
    google.maps.event.addListener(autocomplete, 'place_changed', function() {
      fillAddressFields(this.getPlace(), inputId);
    });
  });

  Array.from(zipCodeElements).forEach((element) => {
    const inputId = element.dataset['inputId'];
    const autocomplete = new google.maps.places.Autocomplete(element, { types: ['postal_code'] });
    google.maps.event.addListener(autocomplete, 'place_changed', function() {
      fillAddressFields(this.getPlace(), inputId);
    });
  });
}

function fillAddressFields(place, inputId) {
  if (!place.address_components) return;

  for (const component of place.address_components) {
    for (const type of component.types) {
      const targetElement = document.getElementById(type + '_' + inputId);
      if (targetElement) {
        targetElement.value = component.short_name;
        targetElement.dispatchEvent(new Event('change'));
      }
    }
  }
}

window.addEventListener('load', initializeAutocomplete);

window.initializeAutocomplete = initializeAutocomplete;
